export default class LoginPassword {
  public static of(value: string): LoginPassword {
    return new LoginPassword(value);
  }
  public static empty(): LoginPassword {
    return LoginPassword.of("");
  }

  private readonly _value: string = "";

  constructor(value: string) {
    this._value = value;
  }

  public isEmpty(): boolean {
    return !this._value;
  }

  get value() {
    return this.isEmpty() ? "" : this._value;
  }
}